import React from 'react'

const ConstructionIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="construction-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 50, 1)" />
          <stop offset="100%" stopColor="rgba(255, 150, 50, 1)" />
        </linearGradient>
        <filter id="construction-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M2 20L6 16M22 20L18 16M12 12L8 8M16 12L20 8" 
        stroke="url(#construction-gradient)" 
        strokeWidth="2.5" 
        strokeLinecap="round"
        filter="url(#construction-glow)"
      />
      <rect 
        x="6" 
        y="4" 
        width="12" 
        height="4" 
        rx="1" 
        stroke="url(#construction-gradient)" 
        strokeWidth="2"
        filter="url(#construction-glow)"
      />
      <path 
        d="M3 18L21 18M8 16V8M16 16V8" 
        stroke="url(#construction-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        opacity="0.6"
      />
      <circle cx="12" cy="6" r="1" fill="url(#construction-gradient)" />
    </svg>
  )
}

export default ConstructionIcon
